
















import { Component, Mixins, Emit } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../../../base/components/system/mixins";
import { IEditableFormatQuestionnaireSubmissionEndpoint } from "../../../../../../domain/editableFormat";

@Component
export default class FormatQuestionnaireSubmissionEndpointPropertyEditor extends Mixins(ModelEditableMixin) {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: IEditableFormatQuestionnaireSubmissionEndpoint) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IEditableFormatQuestionnaireSubmissionEndpoint) => T, defaultValue: T) => T;

  get valueUrl(): string {
    return this.readPropertyOrDefault(s => s.valueUrl, "");
  }

  set valueUrl(value: string) {
    this.writePropertyWhenValid(s => s.valueUrl = value);
  }

  @Emit()
  deleteProperty() {}
}
